import React from 'react';

import { usePageView } from '../hooks/useTracking';
import type { Pageview } from '../services/Pageview';

interface PageViewProps {
  name: Pageview;
}

export function PageView({ name, children }: React.PropsWithChildren<PageViewProps>): JSX.Element {
  usePageView(name);

  if (!children) return null;
  return children as JSX.Element;
}
